import { render, staticRenderFns } from "./ShaqFAQ.vue?vue&type=template&id=b961e4d4&scoped=true&"
import script from "./ShaqFAQ.vue?vue&type=script&lang=ts&"
export * from "./ShaqFAQ.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b961e4d4",
  null
  
)

export default component.exports